import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RegningerPage } from './regninger.page';
import { MainPipe } from 'src/app/services/pipes/main-pipe.module';
import { routes } from './regninger.routes';
import { FakturaPopupPage } from './faktura-popup/faktura-popup.page';
import { PdffakturaPage } from './pdffaktura/pdffaktura.page';
import { ComponentsModule } from 'src/app/shared/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MainPipe,
    FakturaPopupPage,
    PdffakturaPage,
    ComponentsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [RegningerPage]
})
export class RegningerPageModule {}
